import { MainLayoutAttr, MainLayoutTooltips } from '../types/main.layout-attr';
import { Breadcrumb } from '../types/breadcrumb';

export class MainLayoutStoreState {
  layoutAttr: MainLayoutAttr = {
    navType: 'st5',
    themeLayout: 'vertical',
    layoutType: '',
    verticalPlacement: 'left',
    verticalLayout: 'wide',
    deviceType: 'desktop',
    verticalNavType: 'expanded',
    verticalEffect: 'shrink',
    vNavigationView: 'view1',
    pCodedHeaderPosition: 'fixed',
    pCodedSidebarPosition: 'fixed',
    headerTheme: 'theme1',
    logoTheme: 'theme1',
    navBarTheme: 'themelight1',
    activeItemTheme: 'theme1',
    itemBorder: true,
    itemBorderStyle: 'none',
    dropDownIcon: 'style1',
    subItemIcon: 'style6',
    windowWidth: 0,
    isCollapsedMobile: 'no-block',
    headerFixedMargin: '60px',
  };
  tooltipLabels: MainLayoutTooltips = {
    toggleMenu: '',
  };
  breadcrumbs: Breadcrumb[] = [];
}
